<template>
  <span :class="className">
    <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.09286 1.3326C7.44035 0.5558 8.55965 0.555801 8.90714 1.3326C9.44547 2.53603 10.8415 3.11429 12.0731 2.64399C12.8681 2.34042 13.6596 3.13189 13.356 3.92688C12.8857 5.15849 13.464 6.55453 14.6674 7.09286C15.4442 7.44035 15.4442 8.55965 14.6674 8.90714C13.464 9.44547 12.8857 10.8415 13.356 12.0731C13.6596 12.8681 12.8681 13.6596 12.0731 13.356C10.8415 12.8857 9.44547 13.464 8.90714 14.6674C8.55965 15.4442 7.44035 15.4442 7.09286 14.6674C6.55453 13.464 5.15849 12.8857 3.92688 13.356C3.13189 13.6596 2.34042 12.8681 2.64399 12.0731C3.11429 10.8415 2.53603 9.44547 1.3326 8.90714C0.555801 8.55965 0.5558 7.44035 1.3326 7.09286C2.53603 6.55453 3.11429 5.15849 2.64399 3.92688C2.34042 3.13189 3.13189 2.34042 3.92688 2.64399C5.15849 3.11429 6.55453 2.53603 7.09286 1.3326L6.43658 1.03902L7.09286 1.3326Z"
        stroke="#FCFCFD"
        stroke-width="1.5"
      />
      <path
        d="M6.00027 10.7111H6.78757L9.76535 6H8.9844L6.00027 10.7111ZM6.03202 8.63492C6.77488 8.63492 7.18123 8.15238 7.18123 7.32063C7.18123 6.50159 6.77488 6.0254 6.03202 6.0254C5.28916 6.0254 4.88281 6.50159 4.88281 7.32063C4.88281 8.15238 5.28916 8.63492 6.03202 8.63492ZM6.03202 8.0254C5.7463 8.0254 5.59392 7.82222 5.59392 7.32698C5.59392 6.84444 5.7463 6.64127 6.03202 6.64127C6.31138 6.64127 6.47646 6.84444 6.47646 7.32698C6.47646 7.82222 6.31138 8.0254 6.03202 8.0254ZM9.73996 10.7175C10.4765 10.7175 10.8828 10.2349 10.8828 9.40952C10.8828 8.58413 10.4765 8.10794 9.73996 8.10794C8.99075 8.10794 8.5844 8.58413 8.5844 9.40952C8.5844 10.2349 8.99075 10.7175 9.73996 10.7175ZM9.73996 10.1079C9.45424 10.1079 9.29551 9.90476 9.29551 9.41587C9.29551 8.92063 9.45424 8.71746 9.73996 8.71746C10.0193 8.71746 10.1781 8.92063 10.1781 9.41587C10.1781 9.90476 10.0193 10.1079 9.73996 10.1079Z"
        fill="#FCFCFD"
      />
    </svg>
  </span>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'PercentageStar',
  props: {
    width: {
      type: String,
      default: '16px'
    },
    height: {
      type: String,
      default: '16px'
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
